
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ask-agri-question",
      function () {
        return require("private-next-pages/ask-agri-question.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ask-agri-question"])
      });
    }
  